"use client";

import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import NextErrorScreen from "@modules/shared/screen-templates/next-error-screen";
import { useIsLoadingResources } from '@lib/context/shared/loading-resources-context';
export default function MainError(_ref) {
  let {
    error,
    reset
  } = _ref;
  const {
    setIsLoadingPage
  } = useIsLoadingResources();
  const router = useMuscleRouter();
  const resetHandler = reset !== null && reset !== void 0 ? reset : () => {
    router.goHome();
  };

  // Handle uncomplete loading page when error occurs
  useEffect(() => {
    setIsLoadingPage(false);
  }, [setIsLoadingPage]);
  return __jsx(NextErrorScreen, {
    error: error,
    reset: resetHandler
  });
}